export default __webpack_public_path__ + "static/IP_Vision_Pro_01-6ed9b07a7589556724008adeac68b958.webp";